export default "__VITE_ASSET__87b42111__"